import { RefreshableItem } from '../models/refreshableItem';
import { validateExternalReference, ValidateProductParams } from '../utilities/urlParameters';

export const validateParams: ValidateProductParams = ({ externalReference }) => {
  const errors = [];

  const externalReferenceError = validateExternalReference(externalReference || '');

  if (externalReferenceError) {
    errors.push(externalReferenceError);
  }

  return {
    parameters: {
      refreshableItems: [
        RefreshableItem.CHECKING_ACCOUNTS,
        RefreshableItem.SAVING_ACCOUNTS,
        RefreshableItem.CREDITCARD_ACCOUNTS,
        RefreshableItem.CHECKING_TRANSACTIONS,
        RefreshableItem.SAVING_TRANSACTIONS,
        RefreshableItem.CREDITCARD_TRANSACTIONS,
        RefreshableItem.IDENTITY_DATA,
        RefreshableItem.EINVOICES,
      ],
    },
    errors,
  };
};
